import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    Divider,
    Form,
    Input,
    Modal as ServaModal, 
    Row,
} from '@servahealth/serva-ui-kit';
import Report from '../../Interfaces/Responses/Dashboard/Report';
import AutoRunTargetEmail from '../../Interfaces/Responses/Schedules/AutoRunTargetEmail';
import AutoRunTargetFTP from '../../Interfaces/Responses/Schedules/AutoRunTargetFTP';
import AutomaticDeliveryTargetFTP from './AutomaticDeliveryTargetFTP';
import AutomaticDeliveryTargetEmail from './AutomaticDeliveryTargetEmail';

type AutomaticDeliveryAdvancedProps = {
    report: Report | undefined;
    adParentAutoRunID: number | undefined;
    adReportInputID: number | undefined;
    adReportInputs: string | undefined;
    adPreRunSQL: string | undefined;
    adMonitorQueueQuery: string | undefined;
    adFTPTarget: AutoRunTargetFTP | undefined;
    adEmailTarget: AutoRunTargetEmail | undefined;
    handleADAdvancedParentAutoRunIDUpdate: (
    ) => void;
    handleADAdvancedReportInputIDUpdate: (
    ) => void;
    handleADAdvancedReportInputsUpdate: (
    ) => void;
    handleADAdvancedPreRunSQLUpdate: (
    ) => void;
    handleADAdvancedMonitorQueueQueryUpdate: (
    ) => void;
    handleADAutoRunTargetEmailUpdate: (
        autoRunTargetEmail: AutoRunTargetEmail
    ) => void;
    handleADAutoRunTargetFTPUpdate: (
        autoRunTargetFTP: AutoRunTargetFTP
    ) => void;
};

const AutomaticDeliveryAdvanced: React.FC<AutomaticDeliveryAdvancedProps> = ({ ...props }) => {

    const [manageAutoRunTargetFTPModalOpen, setManageAutoRunTargetFTPModalOpen] = useState(false);
    const [manageAutoRunTargetEmailModalOpen, setManageAutoRunTargetEmailModalOpen] = useState(false);

    const [adParentAutoRunID, setADParentAutoRunID] = useState<number | undefined>();
    const [adReportInputID, setADReportInputID] = useState<number | undefined>();
    const [adReportInputs, setADReportInputs] = useState<string | undefined>();
    const [adPreRunSQL, setADPreRunSQL] = useState<string | undefined>();
    const [adMonitorQueueQuery, setADMonitorQueueQuery] = useState<string | undefined>();

    useEffect(() => {

        setADParentAutoRunID(props.adParentAutoRunID ?? 0);
        setADReportInputID(props.adReportInputID ?? 0);
        setADReportInputs(props.adReportInputs ?? '');
        setADPreRunSQL(props.adPreRunSQL ?? '');
        setADMonitorQueueQuery(props.adMonitorQueueQuery ?? '');

        // ---- DEBUG
        // console.log(props.report?.autoRun);
        // ---- ENDDEBUG
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleADAdvancedTargetFTP = () => {
        setManageAutoRunTargetFTPModalOpen(true);
    }

    const handleADAdvancedTargetEmail = () => {
        setManageAutoRunTargetEmailModalOpen(true);
    }

    const handleSetADAutoRunTargetEmail = (autoRunTargetEmail: AutoRunTargetEmail) => {
        props.handleADAutoRunTargetEmailUpdate(autoRunTargetEmail);
    }

    const handleSetADAutoRunTargetFTP = (autoRunTargetFTP: AutoRunTargetFTP) => {
        props.handleADAutoRunTargetFTPUpdate(autoRunTargetFTP);
    }

    return (
        <>
            <ServaModal
                destroyOnHidden={true}
                open={manageAutoRunTargetFTPModalOpen}
                onCancel={() => setManageAutoRunTargetFTPModalOpen(false)}
                hideButtons={true}
                width="40%"
            >
                <AutomaticDeliveryTargetFTP
                    report={props.report}
                    autoRunTargetFTP={props.adFTPTarget}
                    handleSetADAutoRunTargetFTP={handleSetADAutoRunTargetFTP}
                    close={() => setManageAutoRunTargetFTPModalOpen(false)}
                ></AutomaticDeliveryTargetFTP>
            </ServaModal>
            <ServaModal
                destroyOnHidden={true}
                open={manageAutoRunTargetEmailModalOpen}
                onCancel={() => setManageAutoRunTargetEmailModalOpen(false)}
                hideButtons={true}
                width="40%"
            >
                <AutomaticDeliveryTargetEmail
                    report={props.report}
                    autoRunTargetEmail={props.adEmailTarget}
                    handleSetADAutoRunTargetEmail={handleSetADAutoRunTargetEmail}
                    close={() => setManageAutoRunTargetEmailModalOpen(false)}
                ></AutomaticDeliveryTargetEmail>
            </ServaModal>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '8px', lineHeight: '50%' }}>
                <Col span={7}>
                    <div style={{textAlign:'left', width:'100%'}}>
                        <label>Parent AutoRun ID:</label>
                    </div>
                </Col>
                <Col span={1}/>
                <Col span={7}>
                    <div style={{textAlign:'left', width:'100%'}}>
                        <label>Report Input ID:</label>
                    </div>
                </Col>
                <Col span={1}/>
                <Col span={7}>
                    <div style={{textAlign:'left', width:'100%'}}>
                        <label>Report Inputs:</label>
                    </div>
                </Col>
                <Col span={1}/>
            </Row>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '8px', lineHeight: '50%' }}>
                <Col span={7}>
                    <div style={{textAlign:'left', width:'95%'}}>
                        <Form.Item
                            name='adParentAutoRunID'
                            style={{ marginBottom: '0px' }}
                        >
                            <Input
                                size='middle'
                                value={adParentAutoRunID}
                                onChange={() => props.handleADAdvancedParentAutoRunIDUpdate()}
                            ></Input>
                        </Form.Item>
                    </div>
                </Col>
                <Col span={1}/>
                <Col span={7}>
                    <div style={{textAlign:'left', width:'95%'}}>
                        <Form.Item
                            name='adReportInputID'
                            style={{ marginBottom: '0px' }}
                        >
                            <Input
                                size='middle'
                                value={adReportInputID}
                                onChange={() => props.handleADAdvancedReportInputIDUpdate()}
                            ></Input>
                        </Form.Item>
                    </div>
                </Col>
                <Col span={1}/>
                <Col span={8}>
                    <div style={{textAlign:'left', width:'100%'}}>
                        <Form.Item
                            name='adReportInputs'
                            style={{ marginBottom: '0px' }}
                        >
                            <Input
                                size='middle'
                                value={adReportInputs}
                                onChange={() => props.handleADAdvancedReportInputsUpdate()}
                            ></Input>
                        </Form.Item>
                    </div>
                </Col>
            </Row>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '8px', lineHeight: '50%' }}>
                <Col span={22}>
                    <div style={{textAlign:'left'}}>
                        <label>Pre Run SQL:</label>
                    </div>
                </Col>
                <Col span={2}/>
            </Row>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '8px', lineHeight: '50%' }}>
                <Col span={24}>
                    <div style={{textAlign:'left', width:'100%'}}>
                        <Form.Item
                            name='adPreRunSQL'
                            style={{ marginBottom: '0px' }}
                        >
                            <Input
                                size='middle'
                                value={adPreRunSQL}
                                onChange={() => props.handleADAdvancedPreRunSQLUpdate()}
                            ></Input>
                        </Form.Item>
                    </div>
                </Col>
            </Row>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '8px', lineHeight: '50%' }}>
                <Col span={22}>
                    <div style={{textAlign:'left'}}>
                        <label>Monitor Queue Query:</label>
                    </div>
                </Col>
                <Col span={2}/>
            </Row>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '8px', lineHeight: '50%' }}>
                <Col span={24}>
                    <div style={{textAlign:'left', width:'100%'}}>
                        <Form.Item
                            name='adMonitorQueueQuery'
                            style={{ marginBottom: '0px' }}
                        >
                            <Input
                                size='middle'
                                value={adMonitorQueueQuery}
                                onChange={() => props.handleADAdvancedMonitorQueueQueryUpdate()}
                            ></Input>
                        </Form.Item>
                    </div>
                </Col>
            </Row>
            <Row style={{ padding: '0px', margin: '0px', lineHeight: '50%' }}>
                <Col span={24}>
                    <Divider style={{ padding: '0px', paddingBottom: '6px', margin: '0px' }}></Divider>
                </Col>
            </Row>
            <Row style={{ padding: '8px', paddingTop: '2px', paddingBottom: '0px', lineHeight: '50%' }}>
                <Col span={6} style={{display: 'flex', justifyContent: 'center'}}>
                    <div style={{ textAlign: 'left', width: '100%' }}>
                        <Form.Item
                            name="adTargetFTPButton"
                            style={{ marginBottom: '0px', width: '100%' }}
                        >
                            <Button style={{width: '100%'}} type="default" onClick={handleADAdvancedTargetFTP}>
                                &nbsp;FTP Target&nbsp;
                            </Button>
                        </Form.Item>
                    </div>
                </Col>
                <Col span={2}/>
                <Col span={6} style={{display: 'flex', justifyContent: 'center'}}>
                    <div style={{ textAlign: 'left', width: '100%' }}>
                        <Form.Item
                            name="adTargetEmailButton"
                            style={{ marginBottom: '0px', width: '100%' }}
                        >
                            <Button style={{width: '100%'}} type="default" onClick={handleADAdvancedTargetEmail}>
                                Email Target
                            </Button>
                        </Form.Item>
                    </div>
                </Col>
                <Col span={10}/>
            </Row>
        </>
    );
};

export default AutomaticDeliveryAdvanced;
